import {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import axios from 'axios'
import AsyncSelect from 'react-select/async'
import {colourStyles, colourStyles2} from '../../../../components/styles/styles'
import {ErrorMessage, Field, useField} from 'formik'
import {AnimaDireita2} from '../../../../../../../../_metronic/assets/animation/styles'
import Select from 'react-select'
import {MultiSelect} from 'primereact/multiselect'

const API_URL = process.env.REACT_APP_API_URL || 'api'

interface UseOption {
  readonly value: string
  readonly label: string
}

const Step1: FC = () => {
  const [oeid, setOeid] = useState<any>(0)
  const [proid, setProid] = useState<any>(0)

  const intl = useIntl()

  //Constantes de campos do Formik hook UseField
  const [fieldProject, metaProject, helperProject] = useField('project_id')
  const [fieldEntrepreneurID, metaEntrepreneurID, helperEntrepreneurID] =
    useField('entrepreneur_id')
  const [fieldLicenseTypeID, metaLicenseTypeID, helperLicenseTypeID] = useField('license_type_id')
  const [fieldEnterpriseID, , helperEnterpriseID] = useField('enterprise_id')
  const [fieldResponsibleID, metaResponsibleID, helperResponsibleID] = useField('responsiblesT')
  const [, , helperFieldID] = useField('field_id')
  const [, , helperParentID] = useField('parent_id')
  const [fieldIssueOrganID, metaIssueOrganID, helperIssueOrganID] = useField('issue_organ_id')
  const [, , helperRenewable] = useField('renewable')

  //Constantes guadam o valor do input
  const [selectedProject, setSelectedProject] = useState([])
  const [selectedEntrepreneurID, setSelectedEntrepreneurID] = useState([])
  const [selectedLicenseTypeID, setSelectedLicenseTypeID] = useState([])
  const [selectedIssueOrganID, setSelectedIssueOrganID] = useState([])

  const [disableLicenseTypes, setDisableLicenseTypes] = useState(true)
  const [disableUsers, setDisableUsers] = useState(true)

  const [selectedLicenses, setSelectedLicenses] = useState(null)
  const [licenses, setLicenses] = useState([])
  const [selectedEnterprises, setSelectedEnterprises] = useState(null)
  const [enterprises, setEnterprises] = useState([])
  const [selectedFields, setSelectedFields] = useState(null)
  const [fields, setFields] = useState([])
  const [responsables, setResponsables] = useState([])
  const [selectedResponsables, setSelectedResponsables] = useState(null)

  useEffect(() => {
    loadOptionslicenses()
    loadOptionsEnterprises()
    loadOptionFields()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    loadOptionResponsables()
    // eslint-disable-next-line
  }, [proid])

  const loadOptionslicenses = () => {
    setTimeout(() => {
      getLicenses()
      let licenses: any = []
      async function getLicenses() {
        const {data} = await axios.get(API_URL + '/sga/v1/licenses/select2')
        let Response = data.results

        if (Response) {
          for (const element of Response) {
            const license: any = {
              code: element.id,
              name: `Número da Licença: ${element.license_number} - Empreendedor: ${element.entrepreneur.name}  `,
            }
            licenses.push(license)
          }
        }
      }

      setLicenses(licenses)
      return licenses
    }, 2000)
  }

  const loadOptionsEnterprises = () => {
    setTimeout(() => {
      getEnterprises()
      let enterprises: any = []
      let enterpriseSave: any = []
      async function getEnterprises() {
        let options: any = []

        let enterprisesIdinit: any = []
        enterprisesIdinit = fieldEnterpriseID.value.map((e: any) => {
          return e.id
        })
        const {data} = await axios.get(API_URL + '/v1/enterprises/select2')
        let Response = data.results

        if (Response) {
          for (const element of Response) {
            const enterprise: any = {
              code: element.id,
              name: element.text,
            }
            enterprises.push(enterprise)
            enterpriseSave.push(element.id)
            //CONDICIONAL PARA SELECT2 MULTIPLOS
            if (enterprisesIdinit) {
              for (let j = 0; j < enterprisesIdinit.length; j++) {
                if (parseInt(enterprisesIdinit[j]) === element.id) {
                  options.push(enterprise)
                }
                setSelectedEnterprises(options)
              }
            }
          }
        }
      }
      setEnterprises(enterprises)
      helperEnterpriseID.setValue(enterprises)
    }, 2000)
  }
  const loadOptionFields = () => {
    setTimeout(() => {
      getFields()
      let fields: any = []
      async function getFields() {
        const {data} = await axios.get(API_URL + '/v1/fields/select2')
        let Response = data.results

        if (Response) {
          for (const element of Response) {
            const field: any = {
              code: element.id,
              name: element.name,
            }
            fields.push(field)
          }
        }
      }
      setFields(fields)
      return fields
    }, 2000)
  }

  const loadOptionResponsables = () => {
    setTimeout(() => {
      getResponsables()
      let responsables: any = []
      async function getResponsables() {
        let options: any = []

        let responsablesIdinit: any = []
        if (fieldResponsibleID.value) {
          responsablesIdinit = fieldResponsibleID.value.map((e: any) => {
            return e.id
          })
        }

        const {data} = await axios.get(`${API_URL}/v1/users/select2?sga_project_id=${proid}`)

        let Response = data.results

        if (Response.length === 0) {
          setDisableUsers(true)
        }
        if (Response) {
          for (const element of Response) {
            const field: any = {
              code: element.id,
              name: element.username,
            }
            responsables.push(field)
            //CONDICIONAL PARA SELECT2 MULTIPLOS
            if (responsablesIdinit) {
              for (let j = 0; j < responsablesIdinit.length; j++) {
                if (parseInt(responsablesIdinit[j]) === element.id) {
                  options.push(field)
                }
                setSelectedResponsables(options)
              }
            }
          }
        }
      }
      setResponsables(responsables)
      helperResponsibleID.setValue(responsables)
      return responsables
    }, 2000)
  }

  //função de load do select2 de Orgão Emissor -- issue_organ_id
  const loadOptionsIssueOrgan = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getissueOrgan()
      var issueOrgans: any = []
      var options: any[] = []

      let issueOrganIdinit = fieldIssueOrganID.value

      async function getissueOrgan() {
        const {data} = await axios.get(API_URL + '/v1/issue_organs/select2')
        let Response = data.results
        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const issueOrgan: any = {
              value: Response[i].id,
              label: Response[i].name,
            }
            issueOrgans.push(issueOrgan)

            if (parseInt(issueOrganIdinit) === Response[i].id) {
              options.push(issueOrgan)
            }
          }
        }
        setSelectedIssueOrganID(options[0])
      }
      callback(issueOrgans)
    }, 1000)
  }

  //função onchange do select2 de Orgão Emissor -- issue_organ_id
  const handleInputChangeIssueOrganIDs = (event: any) => {
    //limpar o Input dos tipos da Licenças
    setDisableLicenseTypes(true)
    setSelectedLicenseTypeID([])
    helperLicenseTypeID.setValue('')

    setTimeout(() => {
      let inputValue = ''

      inputValue = event.value
      setSelectedIssueOrganID(event)
      helperIssueOrganID.setValue(inputValue)
      setOeid(inputValue)
      setDisableLicenseTypes(false)
      return {inputValue}
    }, 1500)
  }

  //função de load do select2 de Projetos -- project_id
  const loadOptionsProjects = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getProjects()
      var projects: any = []
      var options: any = []
      let projectIdinit = parseInt(fieldProject.value)

      async function getProjects() {
        const {data} = await axios.get(API_URL + '/v1/projects/select2')
        let Response = data.results

        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const project: any = {
              value: Response[i].id,
              label: Response[i].code,
            }
            projects.push(project)

            if (projectIdinit === Response[i].id) {
              options.push(project)
            }
          }
        }
        setSelectedProject(options[0])
      }
      callback(projects)
    }, 500)
  }

  //função onchange do select2 de Projetos -- project_id
  const handleInputChangeProjects = (event: any) => {
    //limpar o Input dos tipos da Licenças
    setDisableUsers(true)
    setSelectedLicenseTypeID([])
    helperLicenseTypeID.setValue('')

    setTimeout(() => {
      var inputValue = ''
      inputValue = event.value
      setSelectedProject(event)
      helperProject.setValue(inputValue)
      setProid(inputValue)
      setDisableUsers(false)
      return {inputValue}
    }, 500)
  }

  //função de load do select2 Empreendedor -- entrepreneur_id
  const loadOptionsEntrepreneurs = (
    inputValue: string,
    callback: (options: UseOption[]) => void
  ) => {
    setTimeout(() => {
      getentrepreneur()
      var entrepreneurs: any = []
      var options: any[] = []

      let entrepreneurIdinit = fieldEntrepreneurID.value

      async function getentrepreneur() {
        const {data} = await axios.get(API_URL + '/v1/entrepreneurs/select2')
        let Response = data.results

        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const entrepreneur: any = {
              value: Response[i].id,
              label: Response[i].name,
            }
            entrepreneurs.push(entrepreneur)

            if (parseInt(entrepreneurIdinit) === Response[i].id) {
              options.push(entrepreneur)
            }
          }
        }
        setSelectedEntrepreneurID(options[0])
      }
      callback(entrepreneurs)
    }, 100)
  }

  //função onchange do select2 Empreendedor -- entrepreneur_id
  const handleInputChangeEntrepreneurIDs = (event: any) => {
    var inputValue = ''
    inputValue = event.value
    setSelectedEntrepreneurID(event)
    helperEntrepreneurID.setValue(inputValue)
    return {inputValue}
  }

  //função de load do select2 de tipo de licença -- license_type_id
  const loadOptionsLicense_Types = (
    inputValue: string,
    callback: (options: UseOption[]) => void
  ) => {
    setTimeout(() => {
      getLicense_Types()
      var licenses: any = []
      var options: any[] = []

      let licenseTypeIdinit = fieldLicenseTypeID.value

      async function getLicense_Types() {
        const {data} = await axios.get(
          API_URL + '/sga/v1/license_types/select2?issue_organ_id=' + oeid
        )
        let Response = data.results

        if (Response.length === 0) {
          setDisableLicenseTypes(true)
          helperRenewable.setValue(false)
        }

        for (var i = 0; i < Response.length; i++) {
          const license: any = {
            value: Response[i].id,
            label: Response[i].abbreviate,
            renewable: Response[i].renewable,
            expire: Response[i].expire,
          }

          licenses.push(license)
          if (parseInt(licenseTypeIdinit) === Response[i].id) {
            options.push(license)
          }
        }
        setSelectedLicenseTypeID(options[0])
      }
      callback(licenses)
    }, 2000)
  }

  //função onchange do select2 de tipo de licença -- license_type_id
  const handleInputChangeLicenseTypeIDs = (event: any) => {
    console.log('event', event)
    if (event) {
      let inputValue = event.value
      let renewable = event.renewable
      setSelectedLicenseTypeID(event)
      helperLicenseTypeID.setValue(inputValue)

      helperRenewable.setValue(renewable)
    }
  }

  //INICIO DO HTML
  return (
    <div className='w-100'>
      <AnimaDireita2>
        <div className='mb-10'>
          <h2 className='fw-bolder text-dark'>
            {intl.formatMessage({id: 'LICENSES.TITLE_STEAP1'})}
          </h2>
          <div className='text-gray-400 fw-bold'>
            {intl.formatMessage({id: 'LICENSES.SUBTITLE_STEAP1'})}
          </div>
        </div>

        <div className='card-body p-0 '>
          {/* inicio da primeira linha */}
          <div className='row'>
            <div className='col-lg-12'>
              <label className='form-label  fw-bold'>
                {intl.formatMessage({id: 'LICENSES.PREVIOUS_LICENSES'})}
              </label>
              <div className='d-flex align-items-start position-relative my-1'>
                <MultiSelect
                  className='form-control form-control-sm form-control-solid p-0 ps-3 border border-white'
                  value={selectedLicenses}
                  options={licenses}
                  style={{
                    fontFamily: 'Poppins',
                    fontSize: '1.15rem',
                    fontWeight: 'medium',
                  }}
                  onChange={(e) => {
                    helperParentID.setValue(e.value)
                    setSelectedLicenses(e.value)
                  }}
                  placeholder={intl.formatMessage({id: 'LICENSES.PREVIOUS_LICENSES'})}
                  optionLabel='name'
                  filter
                  display='chip'
                />
              </div>
            </div>
          </div>
          {/* fim da primeira linha */}

          {/* início da segunda linha */}
          <div className='row mt-3'>
            <div className='col-lg-6'>
              <label className='form-label fw-bold required'>
                {intl.formatMessage({id: 'LICENSES.NUMBER'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Field
                  name='license_number'
                  className='form-control form-control-lg form-control-solid'
                  // placeholder={intl.formatMessage({id: 'LICENSES.license_number'})}
                />
                <div className='text-danger text-center fs-9 fw-bold '>
                  <ErrorMessage name='license_number' />
                </div>
              </div>
            </div>

            <div className='col-lg-6'>
              <label className='form-label fw-bold required'>
                {intl.formatMessage({id: 'ENTREPRENEUR.ENTREPRENEUR_SINGLE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <AsyncSelect
                  {...fieldEntrepreneurID}
                  className='form-control form-control-sm form-control-solid p-0 ps-3'
                  data-kt-license-table-filter='entrepreneur_id'
                  styles={colourStyles}
                  cacheOptions
                  loadOptions={loadOptionsEntrepreneurs}
                  filterOption={(option, inputValue) =>
                    option.label
                      ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                      : false
                  }
                  defaultOptions
                  placeholder={intl.formatMessage({id: 'ENTREPRENEUR.ENTREPRENEUR_SINGLE'})}
                  value={selectedEntrepreneurID}
                  onChange={handleInputChangeEntrepreneurIDs}
                />
                {metaEntrepreneurID.touched && metaEntrepreneurID.error ? (
                  <div className='text-danger text-center fs-9 fw-bold '>
                    {metaEntrepreneurID.error}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          {/* fim da segunda linha */}

          {/* inicio da terceira linha */}
          <div className='row mt-3'>
            <div className='col-lg-6'>
              <label className='form-label fw-bold required'>
                {intl.formatMessage({id: 'PROJECT.PROJECT_SINGLE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <AsyncSelect
                  {...fieldProject}
                  className='form-control form-control-sm form-control-solid p-0 ps-3'
                  data-kt-license-table-filter='project_id'
                  styles={colourStyles}
                  cacheOptions
                  loadOptions={loadOptionsProjects}
                  filterOption={(option, inputValue) =>
                    option.label
                      ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                      : false
                  }
                  defaultOptions
                  placeholder={intl.formatMessage({id: 'PROJECT.SELECT_PLACEHOLDER'})}
                  value={selectedProject}
                  onChange={handleInputChangeProjects}
                />
                {metaProject.touched && metaProject.error ? (
                  <div className='text-danger text-center fs-9 fw-bold '>{metaProject.error}</div>
                ) : null}
              </div>
            </div>

            <div className='col-lg-6'>
              <label className='form-label fw-bold required'>
                {intl.formatMessage({id: 'USERS.TITLE'})} Responsáveis
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                {disableUsers ? (
                  <>
                    <Select
                      className='form-control form-control-lg form-control-transparent p-1 pl-1 ps-6 border border-1 border-gray-400'
                      styles={colourStyles2}
                      isDisabled={true}
                      placeholder={intl.formatMessage({id: 'ENTERPRISES.INPUT_PROJECT_SELECT'})}
                    />
                    {metaProject.touched && metaProject.error ? (
                      <div className='text-danger text-center fs-9 fw-bold '>
                        {metaProject.error}
                      </div>
                    ) : null}
                  </>
                ) : (
                  <>
                    <MultiSelect
                      {...fieldResponsibleID}
                      className='form-control form-control-sm form-control-solid p-0  border-white'
                      value={selectedResponsables}
                      options={responsables}
                      style={{
                        fontFamily: 'Poppins',
                        fontSize: '1.15rem',
                        fontWeight: 'medium',
                      }}
                      onChange={(e) => {
                        helperResponsibleID.setValue(e.value)
                        setSelectedResponsables(e.value)
                      }}
                      placeholder={intl.formatMessage({id: 'LICENSES.PREVIOUS_LICENSES'})}
                      optionLabel='name'
                      filter
                      display='chip'
                    />
                    {metaResponsibleID.touched && metaResponsibleID.error ? (
                      <div className='text-danger text-center fs-9 fw-bold '>
                        {metaResponsibleID.error}
                      </div>
                    ) : null}
                  </>
                )}
              </div>
            </div>
          </div>
          {/* fim da terceira linha */}

          {/* inicio da quarta linha */}
          <div className='row mt-3'>
            <div className='col-lg-6'>
              <label className='form-label fw-bold required'>
                {intl.formatMessage({id: 'LICENSES.ISSUE_ORGAN'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <AsyncSelect
                  {...fieldIssueOrganID}
                  className='form-control form-control-sm form-control-solid p-0 ps-3'
                  data-kt-license-table-filter='issue_organ_id'
                  styles={colourStyles}
                  cacheOptions
                  loadOptions={loadOptionsIssueOrgan}
                  filterOption={(option, inputValue) =>
                    option.label
                      ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                      : false
                  }
                  defaultOptions
                  placeholder={intl.formatMessage({id: 'LICENSES.ISSUE_ORGAN'})}
                  value={selectedIssueOrganID}
                  onChange={handleInputChangeIssueOrganIDs}
                />
                {metaIssueOrganID.touched && metaIssueOrganID.error ? (
                  <div className='text-danger text-center fs-9 fw-bold '>
                    {metaIssueOrganID.error}
                  </div>
                ) : null}
              </div>
            </div>

            <div className='col-lg-6'>
              <label className='form-label fw-bold required'>
                {intl.formatMessage({id: 'LICENSES.TYPE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1 bd-2'>
                {disableLicenseTypes ? (
                  <>
                    <Select
                      className='form-control form-control-lg form-control-transparent p-1 pl-1 ps-6 border border-1 border-gray-400'
                      styles={colourStyles2}
                      isDisabled={true}
                      placeholder={intl.formatMessage({id: 'SELECT.INPUT_RESPONSIBLE_ISSUE_ORGAN'})}
                    />
                    {metaIssueOrganID.touched && metaIssueOrganID.error ? (
                      <div className='text-danger text-center fs-9 fw-bold '>
                        {metaIssueOrganID.error}
                      </div>
                    ) : null}
                  </>
                ) : (
                  <>
                    <AsyncSelect
                      {...fieldLicenseTypeID}
                      className='form-control form-control-sm form-control-solid p-0 ps-3'
                      data-kt-license-table-filter='enterprise_type_id'
                      styles={colourStyles}
                      cacheOptions
                      loadOptions={loadOptionsLicense_Types}
                      // filterOption={(option, inputValue) =>
                      //   option.label
                      //     ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                      //     : false
                      // }
                      defaultOptions
                      placeholder={intl.formatMessage({id: 'LICENSE_TYPES.SELECT'})}
                      value={selectedLicenseTypeID}
                      onChange={handleInputChangeLicenseTypeIDs}
                    />
                    {metaLicenseTypeID.touched && metaLicenseTypeID.error ? (
                      <span className='text-danger text-center fs-9 fw-bold '>
                        {metaLicenseTypeID.error}
                      </span>
                    ) : null}
                  </>
                )}
              </div>
            </div>
          </div>
          {/* fim da quarta linha */}

          {/* inicio da quinta linha */}
          <div className='row mt-3'>
            <div className='col-lg-12'>
              <label className='form-label fw-bold'>
                {intl.formatMessage({id: 'ENTERPRISES.TITLE'})}
              </label>
              <div className='d-flex position-relative my-1'>
                <MultiSelect
                  className='form-control form-control-sm form-control-solid p-0 ps-3 border border-white'
                  value={selectedEnterprises}
                  options={enterprises}
                  style={{
                    fontFamily: 'Poppins',
                    fontSize: '1.15rem',
                    fontWeight: 'medium',
                  }}
                  onChange={(e) => {
                    helperEnterpriseID.setValue(e.value)
                    setSelectedEnterprises(e.value)
                  }}
                  placeholder={intl.formatMessage({id: 'LICENSES.PREVIOUS_LICENSES'})}
                  optionLabel='name'
                  filter
                  display='chip'
                />
              </div>
            </div>
          </div>
          {/* fim da quinta linha */}

          {/* inicio da sexta linha */}
          <div className='row mt-3'>
            <div className='col-lg-12'>
              <label className='form-label  fw-bold required'>
                {intl.formatMessage({id: 'ENTERPRISES.INPUT_FIELDS'})}
              </label>
              <div className='d-flex position-relative my-1'>
                <MultiSelect
                  className='form-control form-control-sm form-control-solid p-0 ps-3 border border-white'
                  value={selectedFields}
                  options={fields}
                  style={{
                    fontFamily: 'Poppins',
                    fontSize: '1.15rem',
                    fontWeight: 'medium',
                  }}
                  onChange={(e) => {
                    helperFieldID.setValue(e.value)
                    setSelectedFields(e.value)
                  }}
                  placeholder={intl.formatMessage({id: 'LICENSES.PREVIOUS_LICENSES'})}
                  optionLabel='name'
                  filter
                  display='chip'
                />
              </div>
            </div>
          </div>
          {/* fim da sexta linha */}

          {/* inicio da setima linha */}
          <div className='row mt-3'>
            <div className='col-lg-12'>
              <label className='form-label fw-bold'>
                {intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Field
                  as='textarea'
                  name='description'
                  className='form-control form-control-lg form-control-solid'
                  rows={5}
                ></Field>
                <div className='text-danger text-center fs-9 fw-bold '>
                  <ErrorMessage name='description' />
                </div>
              </div>
            </div>
          </div>
          {/* fim da setima linha */}
        </div>
      </AnimaDireita2>
    </div>
  )
}

export {Step1}
